// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1h237","validationTips":"StatementDescriptor_validationTips__2RyjO"};